import { render, staticRenderFns } from "./nft-marketplace.vue?vue&type=template&id=1d9a54d8&scoped=true&lang=pug"
import script from "./nft-marketplace.vue?vue&type=script&lang=js"
export * from "./nft-marketplace.vue?vue&type=script&lang=js"
import style0 from "./nft-marketplace.vue?vue&type=style&index=0&id=1d9a54d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a54d8",
  null
  
)

export default component.exports